'use client'

import { useEffect, useState } from 'react'
import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'

import { PostHogScreenTracker } from '@/context/PostHogScreenTracker'

declare global {
  interface Window {
    __posthogStarted__?: boolean
  }
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const [postHogReady, setPostHogReady] = useState(false)

  useEffect(() => {
    if (/\/inactive-account\/recovery\/?$/.test(window.location.pathname))
      return
    const apiKey = process.env.NEXT_PUBLIC_POSTHOG_KEY

    if (!apiKey) {
      console.error('PostHog not initialized: missing API key')
      return
    }
    if (window.__posthogStarted__) {
      setPostHogReady(true)
      return
    }

    posthog.init(apiKey, {
      api_host: 'https://d3eqfjtyxmvv13.cloudfront.net',
      ui_host: 'https://eu.posthog.com',
      defaults: '2025-05-24',
      person_profiles: 'identified_only',
      autocapture: false,
      capture_exceptions: false,
      capture_pageview: true,
      capture_pageleave: true,
      disable_session_recording: true,
      disable_surveys: true,
      disable_surveys_automatic_display: true,
      advanced_disable_decide: false,
      advanced_disable_feature_flags: false,
    })
    window.__posthogStarted__ = true
    setPostHogReady(true)
  }, [])

  return (
    <PHProvider client={posthog}>
      {postHogReady ? <PostHogScreenTracker /> : null}
      {children}
    </PHProvider>
  )
}
